export const environment = {
  production: false,
  apiBaseUrl: 'https://wvard-azfunc-dev-cvx.azurewebsites.net',
  requireAuth: true,
  auth: {
    clientId: 'f3e7d131-6bac-4e02-a473-cdc0341a8756',
    authority: 'https://login.microsoftonline.com/fd799da1-bfc1-4234-a91c-72b3a1cb9e26',
    redirectUri: 'https://wvard-dev-cvx.azurewebsites.net',
    scopes: ['f3e7d131-6bac-4e02-a473-cdc0341a8756/user_impersonation']
  }
};
